export default __webpack_public_path__ + "static/media/uipath-vector-logo.5073c259.png";